// Interfaces (move here from your component file)
import parseToFloat from "../../../components/texts/parseToFloat";

export interface AdvancedSubMandate {
  calculated_mandate_requirement?: number | string;
  joint_fulfillment_in_advanced_biofuel?: number | string;
  allocation_advanced_biofuel_in_gasoline?: number | string;
  allocation_advanced_biofuel_in_diesel?: number | string;
  remaining_volume_advanced_sub_mandate?: number | string;
}

export interface GeneralMandate {
  calculated_mandate_requirement?: number | string;
  joint_fulfillment_in_advanced_biofuel?: number | string;
  joint_fulfillment_in_conventional_biofuel?: number | string;
  allocated_in_advanced_sub_mandate?: number | string;
  allocation_advanced_biofuel_in_gasoline?: number | string;
  allocation_advanced_biofuel_in_diesel?: number | string;
  allocation_conventional_biofuel_in_gasoline?: number | string;
  allocation_conventional_biofuel_in_diesel?: number | string;
  remaining_volume_general_mandate?: number | string;
}

export interface MandateSurplusLocked {
  total_volume_surplus_locked?: number | string;
  advanced_biofuel_in_gasoline_required_by_customers?: number | string;
  advanced_biofuel_in_diesel_required_by_customers?: number | string;
  conventional_biofuel_in_gasoline_required_by_customers?: number | string;
  conventional_biofuel_in_diesel_required_by_customers?: number | string;
  joint_fulfillment_out_advanced_biofuel?: number | string;
  joint_fulfillment_out_conventional_biofuel?: number | string;
  remaining_volume_mandate_surplus_locked?: number | string;
}

export interface MandateSurplusAvailable {
  total_volume_surplus_available?: number | string;
  advanced_biofuel_in_gasoline?: number | string;
  advanced_biofuel_in_diesel?: number | string;
  conventional_biofuel_in_gasoline?: number | string;
  conventional_biofuel_in_diesel?: number | string;
  remaining_volume_mandate_surplus_available?: number | string;
}

export interface VolumeCheck {
  joint_fulfillment_in?: number | string;
  joint_fulfillment_out?: number | string;
  supplied_biofuel?: number | string;
  total_volumes?: number | string;
}

export interface GeneralMandateOffroad {
  calculated_mandate_requirement?: number | string;
  joint_fulfillment_in_advanced_biofuel?: number | string;
  allocation_advanced_fame?: number | string;
  allocation_advanced_hvo_hro?: number | string;
  remaining_volume_general_mandate?: number | string;
  joint_fulfillment_in_advanced_biofuel_comment?: any;
  remaining_volume_general_mandate_comment?: any;
}

export interface MandateSurplusLockedOffroad {
  total_volume_surplus_locked?: number | string;
  advanced_fame_required_by_customers?: number | string;
  advanced_hvo_hro_required_by_customers?: number | string;
  joint_fulfillment_out_advanced_biofuel?: number | string;
  volume_diff_mandate_surplus_locked?: number | string;
  joint_fulfillment_out_advanced_biofuel_comment?: any;
  volume_diff_mandate_surplus_locked_comment?: any;
}

export interface MandateSurplusAvailableOffroad {
  total_volume_surplus_available?: number | string;
  advanced_fame?: number | string;
  advanced_hvo_hro?: number | string;
  volume_adjustment_for_joint_fulfillment_out_advanced_biofuel?: number | string;
  volume_diff_mandate_surplus_available?: number | string;
  volume_diff_mandate_surplus_available_comment?: any;
}

export interface ConventionalBiofuelOffroad {
  total_volume_conventional_biofuel?: number | string;
  conventional_fame?: number | string;
  conventional_hvo_hro?: number | string;
  remaining_volume_conventional_biofuel?: number | string;
  remaining_volume_conventional_biofuel_comment?: any;
}

export interface VolumeCheckOffroad {
  joint_fulfillment_in?: number | string;
  joint_fulfillment_out?: number | string;
  supplied_advanced_biofuel?: number | string;
  supplied_conventional_biofuel?: number | string;
  total_volumes?: number | string;
  joint_fulfillment_in_comment?: any;
  joint_fulfillment_out_comment?: any;
  total_volumes_comment?: any;
}

// Define a type for the input parameters (all values needed for calculations)
export interface PreliminarySurplusParams {
  [key: string]: any; // You can make this more specific if you want
}

export function calculateMandateData(params: {
  generalMandateReqVol: any;
  advancedMandateReqVol: any;
  dieselVol: any;
  dieselBioAboveMandate: any;
  gasolineVol: any;
  gasolineBioAboveMandate: any;
  inJointFulfSum: any;
  inJointFulfConventionalSum: any;
  outJointFulfSum: any;
  outJointFulfConventionalSum: any;
  }) {
  // @ts-ignore
  let {generalMandateReqVol, advancedMandateReqVol, dieselVol, dieselBioAboveMandate, gasolineVol,
    gasolineBioAboveMandate, inJointFulfSum, inJointFulfConventionalSum, outJointFulfSum, outJointFulfConventionalSum
  } = params;

  generalMandateReqVol = Math.ceil(generalMandateReqVol);
  advancedMandateReqVol = Math.ceil(advancedMandateReqVol);

  const fameToBeUsed = parseFloat(dieselVol.fame) - parseFloat(dieselBioAboveMandate.fame);
  const fameAdvToBeUsed = parseFloat(dieselVol.fame_advanced) - parseFloat(dieselBioAboveMandate.fame_advanced);
  const hvoToBeUsed = parseFloat(dieselVol.hvo_hro) - parseFloat(dieselBioAboveMandate.hvo_hro);
  const hvoAdvToBeUsed = parseFloat(dieselVol.hvo_hro_advanced) - parseFloat(dieselBioAboveMandate.hvo_hro_advanced);
  const etanolToBeUsed = parseFloat(gasolineVol.etanol) - parseFloat(gasolineBioAboveMandate.etanol);
  const etanolAdvToBeUsed = parseFloat(gasolineVol.etanol_advanced) - parseFloat(gasolineBioAboveMandate.etanol_advanced);
  const naftaToBeUsed = parseFloat(gasolineVol.nafta) - parseFloat(gasolineBioAboveMandate.nafta);
  const naftaAdvToBeUsed = parseFloat(gasolineVol.nafta_advanced) - parseFloat(gasolineBioAboveMandate.nafta_advanced);
  const biogasolineToBeUsed = parseFloat(gasolineVol.bio_gasoline) - parseFloat(gasolineBioAboveMandate.bio_gasoline);
  const biogasolineAdvToBeUsed = parseFloat(gasolineVol.bio_gasoline_advanced) - parseFloat(gasolineBioAboveMandate.bio_gasoline_advanced);
  const fameBioAboveMandate = parseFloat(dieselBioAboveMandate.fame);
  const fameAdvBioAboveMandate = parseFloat(dieselBioAboveMandate.fame_advanced);
  const hvoBioAboveMandate = parseFloat(dieselBioAboveMandate.hvo_hro);
  const hvoAdvBioAboveMandate = parseFloat(dieselBioAboveMandate.hvo_hro_advanced);
  const etanolBioAboveMandate = parseFloat(gasolineBioAboveMandate.etanol);
  const etanolAdvBioAboveMandate = parseFloat(gasolineBioAboveMandate.etanol_advanced);
  const naftaBioAboveMandate = parseFloat(gasolineBioAboveMandate.nafta);
  const naftaAdvBioAboveMandate = parseFloat(gasolineBioAboveMandate.nafta_advanced);
  const biogasolineBioAboveMandate = parseFloat(gasolineBioAboveMandate.bio_gasoline);
  const biogasolineAdvBioAboveMandate = parseFloat(gasolineBioAboveMandate.bio_gasoline_advanced);
  const surplusRequiredByCustomers = parseFloat(gasolineBioAboveMandate.etanol)
      + parseFloat(gasolineBioAboveMandate.etanol_advanced)
      + parseFloat(gasolineBioAboveMandate.nafta)
      + parseFloat(gasolineBioAboveMandate.nafta_advanced)
      + parseFloat(gasolineBioAboveMandate.bio_gasoline)
      + parseFloat(gasolineBioAboveMandate.bio_gasoline_advanced)
      + parseFloat(dieselBioAboveMandate.fame)
      + parseFloat(dieselBioAboveMandate.fame_advanced)
      + parseFloat(dieselBioAboveMandate.hvo_hro)
      + parseFloat(dieselBioAboveMandate.hvo_hro_advanced);

  const calcMandateReq = advancedMandateReqVol;
  const jointFulfInAdv = inJointFulfSum;

  let allocationAdvBioInGasoline = 0;
  const totalVol = etanolAdvToBeUsed + naftaAdvToBeUsed + biogasolineAdvToBeUsed;
  const diff = calcMandateReq - inJointFulfSum;
  if (totalVol >= diff) {
    allocationAdvBioInGasoline = diff;
  } else if (totalVol > 0) {
    allocationAdvBioInGasoline = totalVol;
  } else {
    allocationAdvBioInGasoline = 0;
  }

  let allocationAdvBioInDiesel = 0;
  const totalVol2 = fameAdvToBeUsed + hvoAdvToBeUsed;
  const diff2 = calcMandateReq - inJointFulfSum - allocationAdvBioInGasoline;
  if (totalVol2 >= diff2) {
    allocationAdvBioInDiesel = diff2;
  } else if (totalVol2 > 0) {
    allocationAdvBioInDiesel = totalVol2;
  } else {
    allocationAdvBioInDiesel = 0;
  }

  const remainingVolAdvSubMandate = calcMandateReq - inJointFulfSum -
      allocationAdvBioInGasoline - allocationAdvBioInDiesel;

  const calcMandateReqGeneral = generalMandateReqVol;
  const jointFulfInConventional = inJointFulfConventionalSum;
  const allocatedInAdvancedSubMandate = allocationAdvBioInGasoline + allocationAdvBioInDiesel;

  let allocationAdvBioInGasolineGeneral = 0;
  if (totalVol > inJointFulfSum) {
    const remaining = totalVol - inJointFulfSum;
    const halfAdjusted = (calcMandateReqGeneral -
        (inJointFulfSum + inJointFulfConventionalSum + allocatedInAdvancedSubMandate)) / 2;
    if (remaining >= halfAdjusted) {
      allocationAdvBioInGasolineGeneral = halfAdjusted;
    } else {
      if (remaining > 0) {
        allocationAdvBioInGasolineGeneral = remaining;
      } else {
        allocationAdvBioInGasolineGeneral = 0;
      }
    }
  }

  let allocationAdvBioInDieselGeneral = 0;
  if (totalVol2 > allocationAdvBioInDiesel) {
    const remaining2 = totalVol2 - allocationAdvBioInDiesel;
    const halfAdjusted2 = (calcMandateReqGeneral - (inJointFulfSum +
        inJointFulfConventionalSum + allocatedInAdvancedSubMandate + allocationAdvBioInGasolineGeneral)) / 2;
    if (remaining2 >= halfAdjusted2) {
      allocationAdvBioInDieselGeneral = halfAdjusted2;
    } else {
      if (remaining2 > 0) {
        allocationAdvBioInDieselGeneral = remaining2;
      } else {
        allocationAdvBioInDieselGeneral = 0;
      }
    }
  }

  let allocationConventionalBioInGasolineGeneral = 0;
  const totalVol3 = etanolToBeUsed + naftaToBeUsed + biogasolineToBeUsed;
  const diff3 = calcMandateReqGeneral - inJointFulfSum - inJointFulfConventionalSum -
      allocatedInAdvancedSubMandate - (allocationAdvBioInGasolineGeneral*2) - (allocationAdvBioInDieselGeneral*2);
  if (totalVol3 >= diff3) {
    allocationConventionalBioInGasolineGeneral = diff3;
  } else {
    if (diff3 > 0) {
      allocationConventionalBioInGasolineGeneral = totalVol3;
    } else {
      allocationConventionalBioInGasolineGeneral = 0;
    }
  }

  let allocationConventionalBioInDieselGeneral = 0;
  const totalVol4 = fameToBeUsed + hvoToBeUsed;
  const diff4 = calcMandateReqGeneral - inJointFulfSum - inJointFulfConventionalSum - allocatedInAdvancedSubMandate -
  (allocationAdvBioInGasolineGeneral*2) - (allocationAdvBioInDieselGeneral*2) -
      allocationConventionalBioInGasolineGeneral;
  if (totalVol4 >= diff4) {
    allocationConventionalBioInDieselGeneral = diff4;
  } else {
    if (diff4 > 0) {
      allocationConventionalBioInDieselGeneral = totalVol4;
    } else {
      allocationConventionalBioInDieselGeneral = 0;
    }
  }

  const remainingVolGeneralMandate = calcMandateReqGeneral - inJointFulfSum - inJointFulfConventionalSum - allocatedInAdvancedSubMandate - (allocationAdvBioInGasolineGeneral*2) - (allocationAdvBioInDieselGeneral*2) - allocationConventionalBioInGasolineGeneral - allocationConventionalBioInDieselGeneral;

  const totalVolSurplusLocked = surplusRequiredByCustomers + outJointFulfConventionalSum + outJointFulfSum;
  const advancedBioInGasolineRequiredByCustomers = etanolAdvBioAboveMandate + naftaAdvBioAboveMandate + biogasolineAdvBioAboveMandate;
  const advancedBioInDieselRequiredByCustomers = fameAdvBioAboveMandate + hvoAdvBioAboveMandate;
  const conventionalBioInGasolineRequiredByCustomers = etanolBioAboveMandate + naftaBioAboveMandate + biogasolineBioAboveMandate;
  const conventionalBioInDieselRequiredByCustomers = fameBioAboveMandate + hvoBioAboveMandate;
  let jointFulfOutAdvancedBio: any = "N/A";
  if (outJointFulfSum > 0) {
    const totalVol5 = fameAdvToBeUsed + hvoAdvToBeUsed;
    const sumH = allocatedInAdvancedSubMandate + allocationAdvBioInGasolineGeneral + allocationAdvBioInDieselGeneral;
    if (sumH < totalVol5) {
      const diff5 = totalVol5 - sumH;
      if (diff5 > outJointFulfSum) {
        jointFulfOutAdvancedBio = outJointFulfSum;
      } else {
        jointFulfOutAdvancedBio = diff5;
      }
    } else {
      jointFulfOutAdvancedBio = 0;
    }
  }

  const jointFulfOutConventionalBio = 0;
  const remainingVolMandateSurplusLocked = totalVolSurplusLocked - advancedBioInGasolineRequiredByCustomers - advancedBioInDieselRequiredByCustomers - conventionalBioInGasolineRequiredByCustomers -
      conventionalBioInDieselRequiredByCustomers - (jointFulfOutAdvancedBio == "N/A" ? 0 : jointFulfOutAdvancedBio) - jointFulfOutConventionalBio;

  const advancedBioInGasolineAvailable = etanolAdvToBeUsed + naftaAdvToBeUsed + biogasolineAdvToBeUsed - allocationAdvBioInGasoline - allocationAdvBioInGasolineGeneral;
  const advancedBioInDieselAvailable = fameAdvToBeUsed + hvoAdvToBeUsed - allocationAdvBioInDiesel - allocationAdvBioInDieselGeneral;
  const conventionalBioInGasolineAvailable = etanolToBeUsed + naftaToBeUsed + biogasolineToBeUsed - allocationConventionalBioInGasolineGeneral;
  const conventionalBioInDieselAvailable = fameToBeUsed + hvoToBeUsed - allocationConventionalBioInDieselGeneral;
  const totalVolSurplusAvailable = advancedBioInGasolineAvailable + advancedBioInDieselAvailable + conventionalBioInGasolineAvailable + conventionalBioInDieselAvailable;
  const remainingVolMandateSurplusAvailable = 0;
  return {
      advancedSubMandate: {
        calculated_mandate_requirement: calcMandateReq,
        joint_fulfillment_in_advanced_biofuel: jointFulfInAdv === 0 ? "N/A" : jointFulfInAdv,
        allocation_advanced_biofuel_in_gasoline: allocationAdvBioInGasoline,
        allocation_advanced_biofuel_in_diesel: allocationAdvBioInDiesel,
        remaining_volume_advanced_sub_mandate: remainingVolAdvSubMandate,
      },
      generalMandate: {
        calculated_mandate_requirement: calcMandateReqGeneral,
        joint_fulfillment_in_advanced_biofuel: jointFulfInAdv === 0 ? "N/A" : jointFulfInAdv,
        joint_fulfillment_in_conventional_biofuel: jointFulfInConventional === 0 ? "N/A" : jointFulfInConventional,
        allocated_in_advanced_sub_mandate: allocatedInAdvancedSubMandate,
        allocation_advanced_biofuel_in_gasoline: allocationAdvBioInGasolineGeneral,
        allocation_advanced_biofuel_in_diesel: allocationAdvBioInDieselGeneral,
        allocation_conventional_biofuel_in_gasoline: allocationConventionalBioInGasolineGeneral,
        allocation_conventional_biofuel_in_diesel: allocationConventionalBioInDieselGeneral,
        remaining_volume_general_mandate: remainingVolGeneralMandate,
      },
      mandateSurplusLocked: {
        total_volume_surplus_locked: totalVolSurplusLocked,
        advanced_biofuel_in_gasoline_required_by_customers: advancedBioInGasolineRequiredByCustomers == 0 ? "N/A" : advancedBioInGasolineRequiredByCustomers,
        advanced_biofuel_in_diesel_required_by_customers: advancedBioInDieselRequiredByCustomers == 0 ? "N/A" : advancedBioInDieselRequiredByCustomers,
        conventional_biofuel_in_gasoline_required_by_customers: conventionalBioInGasolineRequiredByCustomers == 0 ? "N/A" : conventionalBioInGasolineRequiredByCustomers,
        conventional_biofuel_in_diesel_required_by_customers: conventionalBioInDieselRequiredByCustomers == 0 ? "N/A" : conventionalBioInDieselRequiredByCustomers,
        joint_fulfillment_out_advanced_biofuel: jointFulfOutAdvancedBio,
        joint_fulfillment_out_conventional_biofuel: jointFulfOutConventionalBio,
        remaining_volume_mandate_surplus_locked: remainingVolMandateSurplusLocked,
      },
      mandateSurplusAvailable: {
        total_volume_surplus_available: totalVolSurplusAvailable,
        advanced_biofuel_in_gasoline: advancedBioInGasolineAvailable,
        advanced_biofuel_in_diesel: advancedBioInDieselAvailable,
        conventional_biofuel_in_gasoline: conventionalBioInGasolineAvailable,
        conventional_biofuel_in_diesel: conventionalBioInDieselAvailable,
        remaining_volume_mandate_surplus_available: remainingVolMandateSurplusAvailable,
      }
  };
}

export function calculateVolumeCheck(params: {
  inJointFulfSum: any;
  inJointFulfConventionalSum: any;
  outJointFulfSum: any;
  outJointFulfConventionalSum: any;
  jointFulfOutAdvancedBio: any;
  jointFulfOutConventionalBio: any;
  fameSoldVol: any;
  fameAdvSoldVol: any;
  hvoSoldVol: any;
  hvoAdvSoldVol: any;
  etanolSoldVol: any;
  etanolAdvSoldVol: any;
  naftaSoldVol: any;
  naftaAdvSoldVol: any;
  biogasolineSoldVol: any;
  biogasolineAdvSoldVol: any;
  allocatedInAdvancedSubMandate: any;
  allocationAdvBioInGasolineGeneral: any;
  allocationAdvBioInDieselGeneral: any;
  allocationConventionalBioInGasolineGeneral: any;
  allocationConventionalBioInDieselGeneral: any;
  advancedBioInGasolineRequiredByCustomers: any;
  advancedBioInDieselRequiredByCustomers: any;
  conventionalBioInGasolineRequiredByCustomers: any;
  conventionalBioInDieselRequiredByCustomers: any;
  advancedBioInGasolineAvailable: any;
  advancedBioInDieselAvailable: any;
  conventionalBioInGasolineAvailable: any;
  conventionalBioInDieselAvailable: any;
}) {
  let {inJointFulfSum, inJointFulfConventionalSum, outJointFulfSum,
    outJointFulfConventionalSum, jointFulfOutAdvancedBio, jointFulfOutConventionalBio, fameSoldVol, fameAdvSoldVol,
    hvoSoldVol, hvoAdvSoldVol, etanolSoldVol, etanolAdvSoldVol, naftaSoldVol, naftaAdvSoldVol, biogasolineSoldVol,
    biogasolineAdvSoldVol, allocatedInAdvancedSubMandate, allocationAdvBioInGasolineGeneral, allocationAdvBioInDieselGeneral, 
    allocationConventionalBioInGasolineGeneral, allocationConventionalBioInDieselGeneral, advancedBioInGasolineRequiredByCustomers, 
    advancedBioInDieselRequiredByCustomers, conventionalBioInGasolineRequiredByCustomers, conventionalBioInDieselRequiredByCustomers, 
    advancedBioInGasolineAvailable, advancedBioInDieselAvailable, conventionalBioInGasolineAvailable, conventionalBioInDieselAvailable
  } = params;
  const jointFulfInAdv = inJointFulfSum;
  const jointFulfInConventional = inJointFulfConventionalSum ;
  allocatedInAdvancedSubMandate = allocatedInAdvancedSubMandate == "N/A" ? 0 : allocatedInAdvancedSubMandate;
  allocationAdvBioInGasolineGeneral = allocationAdvBioInGasolineGeneral == "N/A" ? 0 : allocationAdvBioInGasolineGeneral;
  allocationAdvBioInDieselGeneral = allocationAdvBioInDieselGeneral == "N/A" ? 0 : allocationAdvBioInDieselGeneral;
  allocationConventionalBioInGasolineGeneral = allocationConventionalBioInGasolineGeneral == "N/A" ? 0 : allocationConventionalBioInGasolineGeneral;
  allocationConventionalBioInDieselGeneral = allocationConventionalBioInDieselGeneral == "N/A" ? 0 : allocationConventionalBioInDieselGeneral;
  advancedBioInGasolineRequiredByCustomers = advancedBioInGasolineRequiredByCustomers == "N/A" ? 0 : advancedBioInGasolineRequiredByCustomers;
  advancedBioInDieselRequiredByCustomers = advancedBioInDieselRequiredByCustomers == "N/A" ? 0 : advancedBioInDieselRequiredByCustomers;
  conventionalBioInGasolineRequiredByCustomers = conventionalBioInGasolineRequiredByCustomers == "N/A" ? 0 : conventionalBioInGasolineRequiredByCustomers;
  conventionalBioInDieselRequiredByCustomers = conventionalBioInDieselRequiredByCustomers == "N/A" ? 0 : conventionalBioInDieselRequiredByCustomers;
  advancedBioInGasolineAvailable = advancedBioInGasolineAvailable == "N/A" ? 0 : advancedBioInGasolineAvailable;
  advancedBioInDieselAvailable = advancedBioInDieselAvailable == "N/A" ? 0 : advancedBioInDieselAvailable;
  conventionalBioInGasolineAvailable = conventionalBioInGasolineAvailable == "N/A" ? 0 : conventionalBioInGasolineAvailable;
  conventionalBioInDieselAvailable = conventionalBioInDieselAvailable == "N/A" ? 0 : conventionalBioInDieselAvailable;
  const jointFulfIn = inJointFulfSum + inJointFulfConventionalSum - jointFulfInAdv - jointFulfInConventional;
  const jointFulfOut = outJointFulfSum + outJointFulfConventionalSum - (jointFulfOutAdvancedBio == "N/A" ? 0 : jointFulfOutAdvancedBio) - (jointFulfOutConventionalBio == "N/A" ? 0 : jointFulfOutConventionalBio);
  const suppliedBiofuel = etanolSoldVol + etanolAdvSoldVol + naftaSoldVol + naftaAdvSoldVol + biogasolineSoldVol + biogasolineAdvSoldVol
      + fameSoldVol + fameAdvSoldVol + hvoSoldVol + hvoAdvSoldVol - (allocatedInAdvancedSubMandate + allocationAdvBioInGasolineGeneral +
          allocationAdvBioInDieselGeneral + allocationConventionalBioInGasolineGeneral + allocationConventionalBioInDieselGeneral +
          advancedBioInGasolineRequiredByCustomers + advancedBioInDieselRequiredByCustomers + conventionalBioInGasolineRequiredByCustomers +
          conventionalBioInDieselRequiredByCustomers + advancedBioInGasolineAvailable + advancedBioInDieselAvailable + conventionalBioInGasolineAvailable + conventionalBioInDieselAvailable);
  const totalVolumes = jointFulfIn + jointFulfOut + suppliedBiofuel;
  return {
    volumeCheck : {
      joint_fulfillment_in: jointFulfIn,
      joint_fulfillment_out: jointFulfOut,
      supplied_biofuel: suppliedBiofuel,
      total_volumes: totalVolumes,
    }
  };
}

export function calculateTotalSurplusOffroad(params: {
  generalMandateReqVol: any;
  fameAdvBioToBeUsed: any;
  hvoAdvBioToBeUsed: any;
  fameAdvBioAboveMandate: any;
  hvoAdvBioAboveMandate: any;
  fameAdvSoldVol: any;
  hvoAdvSoldVol: any;
  inJointFulfSum: any;
  outJointFulfSum: any;
}) {
  const {generalMandateReqVol, fameAdvBioToBeUsed, hvoAdvBioToBeUsed, fameAdvBioAboveMandate, hvoAdvBioAboveMandate,
    fameAdvSoldVol, hvoAdvSoldVol, inJointFulfSum, outJointFulfSum
  } = params;
  const calcMandateReq = Math.ceil(generalMandateReqVol);
  const jointFulfillIn = inJointFulfSum === 0 ? "N/A" : inJointFulfSum;
  const x = jointFulfillIn === "N/A" ? 0 : jointFulfillIn;

  let allocation_advanced_fame = 0;
  const diff = calcMandateReq - x;
  if (fameAdvBioToBeUsed >= diff) {
    allocation_advanced_fame = diff;
  } else if (fameAdvBioToBeUsed > 0) {
    allocation_advanced_fame = fameAdvBioToBeUsed;
  } else {
    allocation_advanced_fame = 0;
  }

  let allocation_advanced_hvo_hro = 0;
  const diffHVO = calcMandateReq - x - allocation_advanced_fame;
  if (hvoAdvBioToBeUsed >= diffHVO) {
    allocation_advanced_hvo_hro = diffHVO;
  } else if (hvoAdvBioToBeUsed > 0) {
    allocation_advanced_hvo_hro = hvoAdvBioToBeUsed;
  } else {
    allocation_advanced_hvo_hro = 0;
  }

  const remaining_volume_general_mandate = calcMandateReq - x - allocation_advanced_fame - allocation_advanced_hvo_hro;

  let joint_fulfillment_out_advanced_biofuel : any = 0;
  const sum_H10_H11 = allocation_advanced_fame + allocation_advanced_hvo_hro;
  const sum_O46_O48 = fameAdvBioToBeUsed + hvoAdvBioToBeUsed;
  if (outJointFulfSum > 0) {
    if (sum_H10_H11 < sum_O46_O48) {
      if ((sum_O46_O48 - sum_H10_H11) > outJointFulfSum) {
        joint_fulfillment_out_advanced_biofuel = outJointFulfSum;
      } else {
        joint_fulfillment_out_advanced_biofuel = sum_O46_O48 - sum_H10_H11;
      }
    } else {
      joint_fulfillment_out_advanced_biofuel = 0;
    }
  } else {
    joint_fulfillment_out_advanced_biofuel = "N/A";
  }

  const sum_H19_to_H21 = fameAdvBioAboveMandate + hvoAdvBioAboveMandate + (joint_fulfillment_out_advanced_biofuel == "N/A" ? 0 : joint_fulfillment_out_advanced_biofuel);
  const total_surplus_available = fameAdvSoldVol + hvoAdvSoldVol - sum_H10_H11 - sum_H19_to_H21;
  const total_volume_surplus_locked = (outJointFulfSum || 0) + fameAdvBioAboveMandate + hvoAdvBioAboveMandate;
  const volume_diff_mandate_surplus_locked = total_volume_surplus_locked - sum_H19_to_H21;
  let mandateStatus = "";
  if (remaining_volume_general_mandate == 0) {
    if (volume_diff_mandate_surplus_locked != 0) {
      mandateStatus = "ERROR Mandate fulfilled, but not surplus LOCKED";
    } else {
      mandateStatus = "OK Mandate fulfilled + surplus LOCKED";
    }
  } else {
    mandateStatus = "ERROR Mandate not fulfilled";
  }
  return {total_surplus_available, mandateStatus};
}
